type ObjectLiteral = { [key: string]: any }

/**
 * Returns a copy of the original object with any null
 * or undefined keys removed.
 *
 * <b>Note:</b> The null/undefined removal is a shallow
 * operation and only affects root properties.
 *
 * @example
 * ```typescript
 * const myObject = {
 *   foo: 42,
 *   bar: null,
 *   baz: undefined,
 *   foobar: {
 *     foobaz: null,
 *   },
 * }
 * const cleanObject = getObjectWithoutNullOrUndefined(myObject)
 *
 * > cleanObject == {
 *     foo: 42,
 *     foobar: {
 *       foobaz: null,
 *     },
 *   }
 * ```
 */
export const getObjectWithoutNullOrUndefined = (obj: ObjectLiteral): any => {
    const getClean = (_obj: ObjectLiteral) => {
        const cleaned: ObjectLiteral = {}

        for (const key of Object.keys(_obj)) {
            if (_obj[key] !== undefined && _obj[key] !== null) {
                cleaned[key] = _obj[key]
            }
        }

        return cleaned
    }

    return getClean(obj)
}
